import { render, staticRenderFns } from "./documentType.vue?vue&type=template&id=c722905c&scoped=true"
import script from "./documentType.vue?vue&type=script&lang=js"
export * from "./documentType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c722905c",
  null
  
)

export default component.exports